module.exports = __webpack_public_path__ + "static/media/session-recording.0f963cec.svg";